import { useEffect, useState } from "react";
export default function useLayerEvents({ onPreRender, onPostRender, }) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [layer, setLayer] = useState();
    useEffect(() => {
        if (!layer)
            return;
        if (onPreRender)
            layer.on("prerender", onPreRender);
        if (onPostRender)
            layer.on("postrender", onPostRender);
        return () => {
            if (onPreRender)
                layer.un("prerender", onPreRender);
            if (onPostRender)
                layer.un("postrender", onPostRender);
        };
    }, [layer, onPreRender, onPostRender]);
    return setLayer;
}
